import React from 'react';
import { Link } from 'react-router-dom';
import { InstagramIcon, LinkedinIcon, TwitterIcon, YoutubeIcon } from 'lucide-react';
import { Logo } from '../shell/Logo';

/**
 * Design B footer. Same destinations the product actually has — nothing here
 * links to a page that does not exist, and no claim of scale or partnership
 * appears.
 */
const COLUMNS = [{
  heading: 'Platform',
  links: [{
    label: 'Academics',
    to: '/academics'
  }, {
    label: 'Campus',
    to: '/community'
  }, {
    label: 'Marketplace',
    to: '/market'
  }, {
    label: 'Housing',
    to: '/housing'
  }, {
    label: 'Money',
    to: '/money'
  }, {
    label: 'Services',
    to: '/services'
  }, {
    label: 'Opportunities',
    to: '/opportunities'
  }]
}, {
  heading: 'For students',
  links: [{
    label: 'Study tools',
    to: '/notes'
  }, {
    label: 'Campus life',
    to: '/social'
  }, {
    label: 'Wallet & payments',
    to: '/money'
  }, {
    label: 'Support',
    to: '/support'
  }, {
    label: 'Discover',
    to: '/discover'
  }]
}, {
  heading: 'For campuses',
  links: [{
    label: 'Campus platform',
    to: '/welcome/campuses'
  }, {
    label: 'Administration',
    to: '/institution'
  }, {
    label: 'Analytics',
    to: '/institution'
  }, {
    label: 'Verification',
    to: '/institution/verification'
  }, {
    label: 'Safety desk',
    to: '/institution/safety'
  }]
}, {
  heading: 'For providers',
  links: [{
    label: 'Become a provider',
    to: '/market/become-a-provider'
  }, {
    label: 'Provider console',
    to: '/provider'
  }, {
    label: 'Verification',
    to: '/identity'
  }, {
    label: 'Representatives',
    to: '/network'
  }]
}, {
  heading: 'Resources',
  links: [{
    label: 'Help centre',
    to: '/support'
  }, {
    label: 'Safety',
    to: '/support'
  }, {
    label: 'Campuses',
    to: '/welcome/campuses'
  }, {
    label: 'Notifications',
    to: '/notifications'
  }]
}, {
  heading: 'Company',
  links: [{
    label: 'About',
    to: '/welcome'
  }, {
    label: 'Contact',
    to: '/support'
  }, {
    label: 'Privacy',
    to: '/legal/privacy'
  }, {
    label: 'Terms',
    to: '/legal/terms'
  }]
}];
const SOCIAL = [{
  label: 'Instagram',
  icon: InstagramIcon
}, {
  label: 'X',
  icon: TwitterIcon
}, {
  label: 'LinkedIn',
  icon: LinkedinIcon
}, {
  label: 'YouTube',
  icon: YoutubeIcon
}];
export function FooterB() {
  return <footer className="bg-brand-900" data-id="element-2483" data-mp="1oh142qa8dfqu">
      <div className="mx-auto max-w-[88rem] px-4 py-14 sm:px-8" data-id="element-2484" data-mp="1oi2m5epnz2i2">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,4fr)]" data-id="element-2485" data-mp="1tfb4bfatb6jb">
          <div data-id="element-2486" data-mp="1yf77xdflkvyc">
            {/* The mark is authored dark; inverted here for the dark field. */}
            <Logo className="brightness-0 invert" data-id="element-2487" data-mp="235dtt5iq62cw" />
            <p className="mt-4 max-w-[30ch] text-body-sm leading-6 text-white/65" data-id="element-2488" data-mp="2378gopdk44jm">
              The digital world of modern campus life. Discover, connect, live, grow.
            </p>
            <ul className="mt-5 flex gap-2" data-id="element-2489" data-mp="1aobb21wabak8">
              {SOCIAL.map(({
              label,
              icon: Icon
            }) => <li key={label} data-id="element-2490" data-mp="134it3ik0pztt">
                  <Link to="/support" aria-label={label} className="flex h-11 w-11 items-center justify-center rounded-lg border border-white/15 text-white/70 transition-colors duration-150 ease-out hover:border-white/40 hover:text-white" data-id="element-2491" data-mp="133r4irou92d1">
                    <Icon aria-hidden className="h-5 w-5" data-id="element-2492" data-mp="k6ziiahww95a" />
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6" data-id="element-2493" data-mp="feoh137iwfam">
            {COLUMNS.map(column => <div key={column.heading} data-id="element-2494" data-mp="af1zihknwcw0">
                <h2 className="text-caption font-semibold uppercase tracking-wide text-white" data-id="element-2495" data-mp="5iuviubttbgp">
                  {column.heading}
                </h2>
                <ul className="mt-3 space-y-2" data-id="element-2496" data-mp="l32fwzg3jax">
                  {column.links.map(link => <li key={link.label} data-id="element-2497" data-mp="3sovv9r3zo9zi">
                      <Link to={link.to} className="text-body-sm text-white/65 transition-colors duration-150 ease-out hover:text-white" data-id="element-2498" data-mp="l7j99lhu2y3s">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-6" data-id="element-2499" data-mp="2ha6a9e832b1">
          <p className="text-caption text-white/50" data-id="element-2500" data-mp="7ho28t2julsp">
            © {new Date().getFullYear()} Campuzon Technologies. A Havazon Ecosystem venture.
          </p>
          <p className="text-caption text-white/50" data-id="element-2501" data-mp="3tnutfi15pq2s">Built for campuses across Nigeria.</p>
        </div>
      </div>
    </footer>;
}